import axios from 'axios'
export const API= axios.create({baseURL:'https://aqueous-coast-61984.herokuapp.com'})
API.interceptors.request.use((req)=>{
if(localStorage.getItem('user')){
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('user')).token}`
}
return req
})